<template>
<div
  class="a-btn text--m text--bold" :class="`${disabled ? 'disabled' : ''} ${outlined ? 'outlined' : ''}`"
  @click="disabled ? null : $emit('click')"
>
  <slot name="default" />
  <img v-if="!!appendIcon" :src="appendIcon" style="margin-left: 16px" height="16px" />
</div>
</template>

<script>
export default {
  name: "a-btn",
  props:{
    disabled:{
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    appendIcon: {
      type: String,
      default: ''
    }
  },
  methods: {
    // getIcon(icon){
    //   const iconUrl = require(`~/assets/${this.icon}`);
    //   return iconUrl || ''
    // }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/SelfService/colors.scss";
@import "~@/styles/SelfService/effects.scss";

.a-btn{
  display: inline-block;
  text-align: center;
  vertical-align: center;
  //flex-direction: row;
  //justify-content: center;
  //align-items: center;
  padding: 12.5px 20px;
  //height: 44px;
  color: white;

  /* Brand 2/Normal */
  background: $brand-2;
  border-radius: 12px;

  &.disabled{
    background: $brand-2-disabled;
  }

  &.outlined{
    color: $primary;
    /* Background/Normal */

    background: $background;
    /* Primary/Normal */

    border: 3px solid $primary;
    box-sizing: border-box;
    border-radius: 12px;
  }
}
.a-btn:not(.disabled):hover{
  box-shadow: $hover--s;
  transition: box-shadow .2s ease;
  cursor: pointer;
}
</style>
